import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const checklistRoutes: Routes = [
  {
    path: 'document-checklist',
    children: [
      {
        path: 'inheritance',
        loadChildren: () =>
          import(
            './public/document-checklist/inheritance/inheritance-document-checklist.module'
          ).then((m) => m.InheritanceDocumentChecklistModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(checklistRoutes)],
  exports: [RouterModule],
})
export class ChecklistRoutingModule {}
